$( function() {

  if ($('body').attr('id') == 'api-landing') {
    var myTextArea_left = document.getElementById("editor1-left");

    var editor1_left = CodeMirror.fromTextArea(myTextArea_left, {
        lineNumbers: true,
        readOnly: true,
        tabsize: 4,
        theme: 'mailjet',
        mode: "text/javascript",
        lineWrapping: true,
      });

  editor1_left.getDoc().setValue(`\r // This API call enables you to send MJML and get the responsive HTML output in return

    curl \\\ \r
    -X POST "https://api.mjml.io/v1/render" \\\ \r
    --user "APPLICATION-ID:SECRET-KEY" \\\ \r
    -d '{ \r
      "mjml":"<mjml><mj-body><mj-container><mj-section><mj-column><mj-text>Hello World</mj-text></mj-column></mj-section></mj-container></mj-body></mjml>" \r
    \t }'`);


    $('.gallery').slick({
        dots: true,
        infinite: false,
        arrows: false,
        slidesToShow: 1.15
    });

    var before = document.getElementById("before");
    $("#before").text(
`MJML

 <mjml>
  <mj-body>
    <mj-container>
      <mj-section>
        <mj-column>
          <mj-text>Hello World!</mj-text>
        </mj-column>
      </mj-section>
    </mj-container>
  </mj-body>
</mjml>



      `
 )
    var editor_before = CodeMirror.fromTextArea(before, {
        readOnly: true,
        tabsize: 4,
        theme: 'mailjet',
        mode: "text/html",
      });
    var after = document.getElementById("after");
    $("#after").text(
            "HTML\n\n"+
`
<!doctype html>
<html xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
<title></title>
<style type="text/css">
  #outlook a { padding: 0; }
  .ReadMsgBody { width: 100%; }
  .ExternalClass { width: 100%; }
  .ExternalClass * { line-height:100%; }
  body { margin: 0; padding: 0; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; }
  table, td { border-collapse:collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; }
  img { border: 0; height: auto; line-height: 100%; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; }
  p { display: block; margin: 13px 0; }
</style>
<!--[if !mso]><!-->
<style type="text/css">
  @import url(https://fonts.googleapis.com/css?family=Ubuntu:300,400,500,700);
</style>
<style type="text/css">
  @media only screen and (max-width:480px) {
    @-ms-viewport { width:320px; }
    @viewport { width:320px; }
  }
</style>
<link href="https://fonts.googleapis.com/css?family=Ubuntu:300,400,500,700" rel="stylesheet" type="text/css">
<!--<![endif]-->
<style type="text/css">
  @media only screen and (min-width:480px) {
    .mj-column-per-100, * [aria-labelledby="mj-column-per-100"] { width:100%!important; }
  }
</style>
</head>
<body>
  <div><!--[if mso]>
      <table border="0" cellpadding="0" cellspacing="0" width="600" align="center" style="width:600px;"><tr><td>
      <![endif]--><div style="margin:0 auto;max-width:600px;"><table cellpadding="0" cellspacing="0" style="font-size:0;width:100%;" align="center" border="0"><tbody><tr><td style="text-align:center;vertical-align:top;font-size:0;padding:20px 0;"><!--[if mso]>
      <table border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:top;width:600px;">
      <![endif]--><div aria-labelledby="mj-column-per-100" class="mj-column-per-100" style="vertical-align:top;display:inline-block;font-size:13px;text-align:left;width:100%;"><table cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="word-break:break-word;font-size:0;padding:10px 25px;" align="left"><div style="cursor:auto;color:#000000;font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:13px;line-height:22px;">Hello World!</div></td></tr></tbody></table></div><!--[if mso]>
      </td></tr></table>
      <![endif]--></td></tr></tbody></table></div><!--[if mso]>
      </td></tr></table>
      <![endif]-->
      <!--[if mso]>
      <table border="0" cellpadding="0" cellspacing="0" width="600" align="center" style="width:600px;"><tr><td>
      <![endif]--><div></div><!--[if mso]>
      </td></tr></table>
      <![endif]--></div>
</body>
</html>
`
);
    var editor_after = CodeMirror.fromTextArea(after, {
        readOnly: true,
        tabsize: 4,
        theme: 'mailjet',
        mode: "text/html",
        scrollbarStyle: null,
      });

    editor_after.addLineClass(0, "text", "homepage-title");
    editor_after.addLineClass(0, "text", "left");
    editor_before.addLineClass(0, "text", "homepage-title");


    $(".CodeMirror-scrollbar-filler").css("display", "none");
    $( document ).ready(function() {
        $("#editor1-left").change(function () {
            editor1_left.setValue($("#editor1-left").text());
            editor1_left.refresh();
        });
        var maxWidth2 = parseInt($("#parent_editors").css("width")) - 30;
        var minWidth = parseInt($("#parent_editors").css("width")) - parseInt($("#after_div").css("width"));
        $(".CodeMirror-scrollbar-filler").css("display", "none");
        $( "#before_div" ).resizable({
            handles: "e",
            maxWidth: maxWidth2,
            minWidth: 25,
          });
        /*
        /*$(".gallery").slick({
            dots: true,
            infinite: false,
            arrows: false,
        });*/
        if($(window).width() >= 450) {
            $('.slick-3').slick('unslick');
        }
        $(".CodeMirror-scrollbar-filler").css("display", "none");
    });
    $(window).resize(function () {
        var maxWidth2 = parseInt($("#parent_editors").css("width")) - 30;
        var minWidth = parseInt($("#parent_editors").css("width")) - parseInt($("#after_div").css("width"));
        $( "#before_div" ).resizable({
            handles: "e",
            maxWidth: maxWidth2,
            minWidth: 25,
          });
    })


    ///////////////////////////////
    ///////////// GTM /////////////
    ///////////////////////////////

    $("a").click(function (e) {
        if ($(this).data('cta') !== undefined) {
            dataLayer.push({
                'event' : 'mjml',
                'eventValue' : 'mjmlHome-CtaClicked',
                'button': $(this).data('cta')
            });
        }
    });

    $("button").click(function (e) {
        if ($(this).data('cta') !== undefined) {
            dataLayer.push({
                'event' : 'mjml',
                'eventValue' : 'mjmlHome-CtaClicked',
                'button': $(this).data('cta')
            });
        }
    });

  }
})
